import Tabs from './tabs';
const els = document.querySelectorAll('.tabs');

for (let el of els) {
    Tabs(el);
}
